import { Component, OnInit} from '@angular/core';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http'; 
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { FormFooterService } from 'src/app/services/form-footer.service';

export function noNumericAfterDotComValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null | any => {
    const companyEmail = control?.value as string;
    const afterDotCom = companyEmail?.substring(companyEmail.lastIndexOf('@'));
    const textSearch = afterDotCom?.substring(afterDotCom.indexOf('.'));
    const containsNumbers = /\d+/g;
    if (textSearch?.match(containsNumbers)) {
      return containsNumbers ? { numericAfterDotCom: true } : null;
    } else if(afterDotCom?.includes('.') != true) {
      return containsNumbers ? { numericAfterDotCom: true } : null;
    }
  };
}

@Component({
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss']
})

export class FormFooterComponent implements OnInit{
  
  countryData: any[] = [];
  baseUrl = environment.BASE_URL;
  customerForm!: FormGroup;
  supplierForm!: FormGroup;

  separateDialCode = false;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];

  constructor(
    public fb: FormBuilder,
    private toastr: ToastrService,
    private inquiry : FormFooterService,
    private service : CommonService
  ){}
  
  ngOnInit() {
    const namePattern = /^[a-zA-Z ]+$/;

    this.customerForm = this.fb.group({
      username : ['', [Validators.required, Validators.maxLength(30), Validators.pattern(namePattern)]],
      companyEmail: ['', [Validators.required, Validators.email, noNumericAfterDotComValidator()]],
      phone: ['', [Validators.required]],
      comments : ['']
    });

    this.supplierForm = this.fb.group({
      username : ['', [Validators.required, Validators.maxLength(30), Validators.pattern(namePattern)]],
      companyEmail: ['', [Validators.required, Validators.email, noNumericAfterDotComValidator()]],
      phone: ['', [Validators.required]],
      comments : ['']
    });

    //this.getCountry();
  }
  imcustomer() {
   
   const payload = {
    username: this.customerForm.value.username,
    companyEmail: this.customerForm.value.companyEmail,
    phone: this.customerForm.value.phone?.e164Number,
    countryCode: this.customerForm.value.phone?.countryCode,
    comments: this.customerForm.value.comments,
    isForCapability:false,
    queryFor: 'Corporate Customer'
   }

    this.service.postDatawithoutHeaders(`${this.baseUrl}customer/lead-management/createCorporateCustomerDeal`, payload).subscribe({
      next: (res:any) => {
          this.toastr.success('Customer Form submitted successfully!');
          this.customerForm.reset();
          
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      }
  })
  }
  imsupplier() {
    
    const payload = {
      username: this.supplierForm.value.username,
      companyEmail: this.supplierForm.value.companyEmail,
      phone: this.supplierForm.value.phone?.e164Number,
      countryCode: this.supplierForm.value.phone?.countryCode,
      comments: this.supplierForm.value.comments,
      isForCapability:false,
      queryFor: 'Corporate Supplier'
     }

    this.service.postDatawithoutHeaders(`${this.baseUrl}supplier/lead-management/createCorporateSupplierDeal`, payload).subscribe({
      next: (res:any) => {
          this.toastr.success('Supplier Form submitted successfully!');
          this.supplierForm.reset();
          
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      }
    })
  }
 
  getCountry() {
    this.service.getData(`${this.baseUrl}common-service/country-management`).subscribe(res => {
      this.countryData = res?.response;
    })
  }
  resetForm(){
    this.customerForm.reset();
  }
  resetSupplier(){
    this.supplierForm.reset();
  }


  isValid() {
    if (this.customerForm.controls['username'].status === 'INVALID' || this.customerForm.controls['companyEmail'].status === 'INVALID' || this.customerForm.controls['phone'].status === 'INVALID') {
      return true;
    } else {
      return false;
    }
  }
  isValidSupplier() {
    if (this.supplierForm.controls['username'].status === 'INVALID' || this.supplierForm.controls['companyEmail'].status === 'INVALID' || this.supplierForm.controls['phone'].status === 'INVALID') {
      return true;
    } else {
      return false;
    }
  }
}
